import { m } from '@pricedrop/i18n';
import type { Notification, NotificationType } from './types';

export const NOTIFICATION_TYPE_OPTIONS: Array<{
  value: NotificationType;
  label: () => string;
}> = [
  { value: 'ANY_CHANGE', label: () => m.notifications_type_any_change() },
  { value: 'PRICE_DROP', label: () => m.notifications_type_price_drop() },
  { value: 'BACK_IN_STOCK', label: () => m.notifications_type_back_in_stock() },
  { value: 'PRICE_BELOW_THRESHOLD', label: () => m.notifications_type_price_below_threshold() },
  { value: 'LOWEST_PRICE', label: () => m.notifications_type_lowest_price() },
];

export function requiresPriceThreshold(type: NotificationType): boolean {
  return type === 'PRICE_BELOW_THRESHOLD';
}

export const EXPIRATION_OPTIONS = [
  { label: () => m.notifications_expiration_1month(), months: 1 },
  { label: () => m.notifications_expiration_3months(), months: 3 },
  { label: () => m.notifications_expiration_6months(), months: 6 },
  { label: () => m.notifications_expiration_1year(), months: 12 },
];

export function getNotificationTypeLabel(type: NotificationType): string {
  const option = NOTIFICATION_TYPE_OPTIONS.find((opt) => opt.value === type);
  return option ? option.label() : type;
}

export function getNotificationButtonText(
  existingNotification: Notification | null,
  isInStock: boolean,
): string {
  if (existingNotification) {
    return m.notifications_bell_update();
  }
  if (!isInStock) {
    return m.notifications_bell_back_in_stock();
  }
  return m.notifications_bell_create();
}
